import React, { createContext, useReducer } from 'react'

import featureReducer from './FeatureReducer'

const initialState = {
  productCatalogues: false,
  loading: true,
  totalPages: 0,
  attendances: false,
  leads: false,
  leaves: false,
  totalEmployee: 0,
  customers: false,
  primarySales: false,
  salesReturn: false,
  incentives: false,
}

export const FeatureContext = createContext(initialState)

export const FeatureContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(featureReducer, initialState)

  function getAllProductCatalogues(productCatalogues, totalPages) {
    dispatch({
      type: 'GET_ALL_PRODUCTCATALOGUES',
      payload: productCatalogues,
      totalPages: totalPages,
    })
  }

  function addProductCatalogues(productCatalogues) {
    dispatch({
      type: 'ADD_PRODUCTCATALOGUE',
      payload: productCatalogues,
    })
  }
  function addCustomer(data) {
    dispatch({
      type: 'ADD_CUSTOMER',
      payload: data,
    })
  }

  function editProductCatalogues(productCatalogues) {
    dispatch({
      type: 'EDIT_PRODUCTCATALOGUE',
      payload: productCatalogues,
    })
  }

  function removeProductCatalogues(id) {
    dispatch({
      type: 'REMOVE_PRODUCTCATALOGUE',
      payload: id,
    })
  }

  function getAllAttendances(data, totalEmployee) {
    dispatch({
      type: 'GET_ALL_ATTENDANCES',
      payload: data,
      totalEmployee: totalEmployee,
    })
  }

  function removeAttendance(id) {
    dispatch({
      type: 'REMOVE_ATTENDANCE',
      payload: id,
    })
  }
  function getAllLeads(data) {
    dispatch({
      type: 'GET_ALL_LEADS',
      payload: data,
    })
  }

  function deleteLead(id) {
    dispatch({
      type: 'REMOVE_LEAD',
      payload: id,
    })
  }

  function addAttendance(data) {
    dispatch({
      type: 'ADD_ATTENDANCE',
      payload: data,
    })
  }
  function addLeave(data) {
    dispatch({
      type: 'ADD_LEAVE',
      payload: data,
    })
  }

  function getAllLeaves(data, totalPages) {
    dispatch({
      type: 'GET_ALL_LEAVES',
      payload: data,
      totalPages: totalPages,
    })
  }

  function removeLeave(id) {
    dispatch({
      type: 'REMOVE_LEAVE',
      payload: id,
    })
  }

  function getAllSingleEmployeeAttendance(data) {
    dispatch({
      type: 'GET_ALL_EMPLOYEE_ATTENDANCE',
      payload: data,
    })
  }

  function removeSingleEmployeeAttendance(id) {
    dispatch({
      type: 'REMOVE_EMPLOYEE_ATTENDANCE',
      payload: id,
    })
  }

  function getAllCustomer(data) {
    dispatch({
      type: 'GET_ALL_CUSTOMERS',
      payload: data,
    })
  }

  function removeCustomer(id) {
    dispatch({
      type: 'REMOVE_CUSTOMER',
      payload: id,
    })
  }

  function getAllPrimarySales(data) {
    dispatch({
      type: 'GET_ALL_PRIMARY_SALES',
      payload: data,
    })
  }

  function addPrimarySales(data) {
    dispatch({
      type: 'ADD_PRIMARY_SALES',
      payload: data,
    })
  }

  function removePrimarySales(id) {
    dispatch({
      type: 'REMOVE_PRIMARY_SALES',
      payload: id,
    })
  }
  function getAllSalesReturn(data) {
    dispatch({
      type: 'GET_ALL_SALES_RETURN',
      payload: data,
    })
  }

  function addSalesReturn(data) {
    dispatch({
      type: 'ADD_SALES_RETURN',
      payload: data,
    })
  }

  function removeSalesReturn(id) {
    dispatch({
      type: 'REMOVE_SALES_RETURN',
      payload: id,
    })
  }

  function getAllIncentives(data) {
    dispatch({
      type: 'GET_ALL_INCENTIVE',
      payload: data,
    })
  }
  function removeIncentives(id) {
    dispatch({
      type: 'REMOVE_INCENTIVE',
      payload: id,
    })
  }

  return (
    <FeatureContext.Provider
      value={{
        getNewProductCatalogues: getAllProductCatalogues,
        productCatalogues: state.productCatalogues,
        // productCatalogues: state.productCatalogues,
        addNewProductCatalogue: addProductCatalogues,
        editNewProductCatalogue: editProductCatalogues,
        deleteNewProductCatalogue: removeProductCatalogues,
        // totalPages: state.totalPages.productCatalogues,
        getNewAttendances: getAllAttendances,
        deleteNewAttendance: removeAttendance,
        attendances: state.attendances,
        getNewLeaves: getAllLeaves,
        deleteNewLeave: removeLeave,
        getNewLeads: getAllLeads,
        deleteNewLead: deleteLead,
        leaves: state.leaves,
        totalEmployee: state.totalEmployee,
        addNewAttendance: addAttendance,
        addNewLeave: addLeave,
        getNewAllSingleEmployeeAttendance: getAllSingleEmployeeAttendance,
        removeNewSingleEmployeeAttendance: removeSingleEmployeeAttendance,
        getNewCustomers: getAllCustomer,
        deleteNewCustomer: removeCustomer,
        customers: state.customers,
        getNewPrimarySales: getAllPrimarySales,
        deleteNewPrimarySales: removePrimarySales,
        addNewPrimarySales: addPrimarySales,
        primarySales: state.primarySales,
        deleteNewIncentive: removeIncentives,
        getNewIncentive: getAllIncentives,
        incentives: state.incentives,
        addNewSalesReturn: addSalesReturn,
        getNewSalesReturn: getAllSalesReturn,
        deleteNewSalesReturn: removeSalesReturn,
        salesReturn: state.salesReturn,
        leads: state.leads,
        addNewCustomer: addCustomer,
      }}
    >
      {children}
    </FeatureContext.Provider>
  )
}
